export const toastVariants = [
  "info",
  "success",
  "warning",
  "error",
  "pending",
  "liquidationNotice",
  "liquidationWarning",
  "liquidationError",
] as const;

export type ToastVariant = (typeof toastVariants)[number];

export interface ToastProps {
  id?: string | number;
  title: string;
  description?: React.ReactNode;
  variant?: ToastVariant;
  duration?: number;
  action?: {
    label?: string;
    onClick?: () => void;
  };
  onDismiss?: (id: string | number) => void;
  onAutoClose?: (id: string | number) => void;
}

export type ToastFunction = (props: ToastProps) => string | number;
export type ToastVariantFunction = (
  props: Omit<ToastProps, "variant">,
) => string | number;
export type Toast = ToastFunction &
  Record<(typeof toastVariants)[number], ToastVariantFunction>;
